import { SimpleWorkspace } from '@opallabs/concepts'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { WorkspaceContext, ThemeProvider } from '@opallabs/hooks'
import { WithTheme } from '@opallabs/lapidary'
import { MomentBoardsPopover, MomentBoardsPopoverProps } from '..'

type QueryableMomentBoardsPopoverProps = Readonly<
  MomentBoardsPopoverProps & WithTheme & { workspace: SimpleWorkspace }
>

export const QueryableMomentBoardsPopover: React.FC<
  QueryableMomentBoardsPopoverProps
> = ({ theme = 'dark', workspace, ...popoverProps }) => (
  <DefaultQueryClientProvider>
    <ThemeProvider theme={theme}>
      <WorkspaceContext.Provider value={workspace}>
        <MomentBoardsPopover {...popoverProps} />
      </WorkspaceContext.Provider>
    </ThemeProvider>
  </DefaultQueryClientProvider>
)
